export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS'
export const SET_CUSTOMER_FLAGS_KEY = 'SET_CUSTOMER_FLAGS_KEY'
export const RESET_FEATURE_FLAGS = 'RESET_FEATURE_FLAGS'
